export default __webpack_public_path__ + "d4d818c524755ba676c54fa1c845fe42.png";